module.exports = __webpack_public_path__ + "static/media/img-talentx-app@3x.a68af5d5.png";